import * as React from "react";
import {memo, useEffect, useState} from "react";
import {bindActionCreators, Dispatch} from "redux";
import {connect} from "react-redux";
import {FormControl, ListItemText, MenuItem, Select} from "@material-ui/core";
import {IOrpyxApplicationStore} from "../../../../../store/application.reducers";
import {PatientStatusTypesSelectors} from "../../../shared/patient-status-types/store/patient-status-types-selectors";
import {PATIENT_STATUS_TYPES_INITIALIZE} from "../../../shared/patient-status-types/store/patient-status-types-actions";
import {PatientsListStatusFilterEvents, PatientsListStatusFilterMeta, PatientsListStatusFilterOwnProps, PatientsListStatusFilterProps} from "./patients-list-status-filter.interface";
import {usePatientsListStatusFilterStyle} from "./patients-list-status-filter.style";

const PatientsListStatusFilterComponent = (props: PatientsListStatusFilterMeta) => {
    const classes = usePatientsListStatusFilterStyle();
    const [selectedStatus, setSelectedStatus] = useState<string>(props.statuses.length > 0 ? String(props.statuses[0]) : '');

    //  Status types are a server-owned lookup, loaded once on first mount of the filter.
    useEffect(() => {
        if (!props.initialized) {
            props.loadStatusTypes();
        }
    }, []);

    useEffect(() => {
        setSelectedStatus(props.statuses.length > 0 ? String(props.statuses[0]) : '');
    }, [props.statuses]);

    const onChange = (event: React.ChangeEvent<{value: unknown}>) => {
        const value = event.target.value as string;
        setSelectedStatus(value);
        props.onSelected(value ? [parseInt(value, 10)] : []);
    };

    const renderValue = (selected: unknown) => {
        const value = selected as string;
        if (!value) {
            return <span className={classes.placeholder}>All Statuses</span>;
        }

        const statusId = parseInt(value, 10);

        return props.statusTypes.find(status => status.patientStatusTypeId === statusId)?.name ?? value;
    };

    return (
        <FormControl className={classes.root}>
            <Select
                displayEmpty
                variant="outlined"
                id="patients-list-status-filter"
                value={selectedStatus}
                onChange={onChange}
                renderValue={renderValue}
                className={classes.selectWrapper}
            >
                <MenuItem value="">
                    <ListItemText primary="All Statuses"/>
                </MenuItem>
                {props.statusTypes.map(status => (
                    <MenuItem key={status.patientStatusTypeId} value={String(status.patientStatusTypeId)}>
                        <ListItemText primary={status.name}/>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

const mapStateToProps = (state: IOrpyxApplicationStore): PatientsListStatusFilterOwnProps => {
    return {
        statusTypes: PatientStatusTypesSelectors.statusTypes(state),
        initialized: PatientStatusTypesSelectors.initialized(state),
    };
};

const mapDispatchToProps = (dispatch: Dispatch, props: PatientsListStatusFilterProps): PatientsListStatusFilterEvents => {
    return bindActionCreators({
        loadStatusTypes: PATIENT_STATUS_TYPES_INITIALIZE,
    }, dispatch);
};

export const PatientsListStatusFilter = memo(connect(mapStateToProps, mapDispatchToProps)(PatientsListStatusFilterComponent));
